import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header/Header";
import { fetchAitsTestListRequest } from "../../../redux/aits/aitsSlice";
import PaperListing from "../components/Header/PaperListing/PaperListing";
import PyqListing from "../components/Header/PaperListing/PyqListing";

function AitsPage() {
  const dispatch = useDispatch();

  const { plannerDetails, testDetails, state } = useSelector(
    (s) => s.examSlice
  );
  const plannerId = plannerDetails?.planner_id;
  const plannerTypeId = plannerDetails?.planner_type_id;
  const paperType = plannerDetails?.id;
  const categoryId = plannerDetails?.category_id;

  useEffect(() => {
    dispatch(
      fetchAitsTestListRequest({
        paperType: paperType,
        plannerId,
        plannerTestType: plannerTypeId,
        year: testDetails?.year || 2025,
        format: testDetails?.format,
        categoryId: categoryId || "",
      })
    );
  }, [
    dispatch,
    plannerId,
    plannerTypeId,
    paperType,
    categoryId,
    testDetails?.year,
    testDetails?.format,
  ]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Header />
      {plannerDetails?.id === 1 ? <PyqListing /> : <PaperListing />}
    </div>
  );
}

export default AitsPage;
